import React from "react"
import { Provider } from "react-redux"
import { store } from "./src/store/store"
import './src/styling/global.css';
import './src/styling/index.css';
import './src/styling/signup.css';
import './src/styling/gallery.css';
import './src/styling/footer.css';
import './src/styling/variables.css';
import "./src/styling/performance.css"


export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <Provider store={store}>{element}</Provider>
)